// Register.js
//
//  Updated 1/25.
//
//  Abstract: Register page component.

//	React
import React, { useState, useEffect, useRef, useReducer } from 'react';
//	Components
import CardTemplate from '../__common__/CardTemplate/CardTemplate.js';
//	Hooks
import useFetch from '../../hooks/useFetch.js';
//	Material-ui styles
import {
	makeStyles,
	Typography,
	FormControl,
	InputLabel,
	Select,
	Grid,
	Button,
	CircularProgress,
	Link,
	TextField
} from '@material-ui/core';

import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(3)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	progess: {
		position: 'absolute'
	},
	logos: {
		width: '75px',
		justifyContent: 'center'
	},
	titleLabel: {
		textAlign: 'center',
		marginLeft: '10px'
	},
	formControl: {
		minWidth: 65,
	},
	titleItem: {
		maxWidth: '65px',
		marginRight: '10px' 
	},
	toast: {
		color: 'green'
	},
	topLabel: {
		textAlign: 'center',
	}
}));

export default function Register(props) {

	//	CSS classes
	const classes = useStyles();
	const history = useHistory();
	const { post } = useFetch();
	
	const titleField = useRef(null);

	//	ref
	useEffect(() => {
		// titleField.current.focus();
	}, []);

	//	Set state
	const [firstName, setFirstName] = useState('');
	const [title, setTitle] = useState('');
	const [lastName, setLastName] = useState('');
	const [organization, setOrganization] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [errors, setErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isRegisteredSuccess, setIsRegisteredSuccess] = useState(false);

	useEffect(() => {
		if (isRegisteredSuccess) {
			setTimeout(() => {
				history.push('/');
			}, 2000);
		}
	}, [isRegisteredSuccess]);

	//	Event handlers
	function handleIsRegisteredSuccessChange() {
		setIsRegisteredSuccess(!isRegisteredSuccess);
	}
	function handleTitleChange(event) {
		setTitle(event.target.value);
	}
	function handleFirstNameChange(event) {
		setFirstName(event.target.value);
	}
	function handleLastNameChange(event) {
		setLastName(event.target.value);
	}
	function handleEmailChange(event) {
		setEmail(event.target.value);
	}
	function handleOrganizationChange(event) {
		setOrganization(event.target.value);
	}
	function handlePasswordChange(event) {
		setPassword(event.target.value);
	}
	function handleConfirmPasswordChange(event) {
		setConfirmPassword(event.target.value);
	}

	function handleSubmit(event) {
		event.preventDefault();
		setIsLoading(true);
		const newUserData = {
			title: title,
			firstName: firstName,
			lastName: lastName,
			email: email,
			organization: organization,
			password: password,
			confirmPassword: confirmPassword
		};
		post('/register', newUserData)
			.then(data => {
				if (data.token) {
					localStorage.setItem('AuthToken', `${data.token}`);
					setIsLoading(false);
					setIsRegisteredSuccess(true);
				} else {
					//	Request (client) error
					console.log(data)
					setErrors(data);
					setIsLoading(false);

				}
			})
			//	Network (server) error
			.catch((error) => {
				console.log(error)
				setErrors(error);
				setIsLoading(false);
			});
	};

	return (
		<>
			<CardTemplate cardMaxWidth={'sm'}>
							<Typography className={classes.topLabel}> 
								Please fill out the below information to begin.
							</Typography>
				<form className={classes.form} noValidate>
					<Grid container spacing={2}>
					{ isRegisteredSuccess &&<Grid item xs={12}> <Typography className={classes.toast} variant='body2'>Successfully registered.</Typography></Grid> }
						<Grid item container spacing={2} direction="row" justify='space-between'>
							<Grid item xs={6} sm={3} className={classes.titleItem} >
								<FormControl className={classes.formControl}>
									<InputLabel className={classes.titleLabel} >Title</InputLabel>
									<Select autoFocus 
										native
										variant="outlined"
										value={title}
										onChange={handleTitleChange}
										inputProps={{
											name: 'age',
											id: 'age-native-simple',
										}}
									>
										<option aria-label="None" value="" />
										<option value={'Dr.'}>Dr.</option>
										<option value={'Mrs.'}>Mrs.</option>
										<option value={'Mrs.'}>Ms.</option>
										<option value={'Mr.'}>Mr.</option>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={5} style={{paddingRight: 0}}>
								<TextField autoFocus
									variant="outlined"
									color="secondary"
									required
									id="firstName"
									label="First Name"
									name="firstName"
									autoComplete="firstName"
									helperText={errors.firstName}
									error={errors.firstName ? true : false}
									onChange={handleFirstNameChange}
								/>
							</Grid>
							<Grid item xs={12} sm={5} >
								<TextField
									variant="outlined"
									color="secondary"
									required
									id="lastName"
									label="Last Name"
									name="lastName"
									autoComplete="lastName"
									helperText={errors.lastName}
									error={errors.lastName ? true : false}
									onChange={handleLastNameChange}
								/>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								color="secondary"
								required
								fullWidth
								id="email"
								label="Email Address"
								name="email"
								autoComplete="email"
								helperText={errors.email}
								error={errors.email ? true : false}
								onChange={handleEmailChange}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								color="secondary"
								required
								fullWidth
								id="organization"
								label="Organization"
								name="organization"
								autoComplete="organization"
								helperText={errors.organization}
								error={errors.organization ? true : false}
								onChange={handleOrganizationChange}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								color="secondary"
								required
								fullWidth
								name="password"
								label="Password"
								type="password"
								id="password"
								autoComplete="current-password"
								helperText={errors.password}
								error={errors.password ? true : false}
								onChange={handlePasswordChange}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								color="secondary"
								required
								fullWidth
								name="confirmPassword"
								label="Confirm Password"
								type="password"
								id="confirmPassword"
								autoComplete="current-password"
								onChange={handleConfirmPasswordChange}
							/>
						</Grid>
					</Grid>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="tertiary"
						className={classes.submit}
						disableElevation
						onClick={handleSubmit}
						disabled={isLoading ||
							!title ||
							!email ||
							!password ||
							!firstName ||
							!lastName ||
							!organization
						}
					>
						Register
						{isLoading && <CircularProgress size={30} className={classes.progess} />}
					</Button>
					<Grid container justify="center">
						<Grid item>
							<Link href="login" color='secondary' variant="body2">
								Already have an account? Login.
								</Link>
						</Grid>
					</Grid>
				</form>
			</CardTemplate>
		</>
	);
}